import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { pageTrackingService } from '@/services/pageTrackingService';

export function usePageTracking() {
  const [location] = useLocation();

  useEffect(() => {
    // Track page view when location changes
    pageTrackingService.trackPageView(location);
  }, [location]);

  return {
    trackAction: (action: string, metadata?: Record<string, any>) => {
      pageTrackingService.trackUserAction(action, metadata);
    }
  };
}